import { Component, OnInit, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SharedService } from '../../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MakePaymentService } from '../make-payment.service';
import { DashboardService } from '../../../dashboard/dashboard.service';
import { DatePipe, PlatformLocation } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { conformToMask } from 'text-mask-core';
import { LoggerService } from '../../../logger/logger.service';
import {CashOnlyDialog} from '../../../dashboard/dashboard/dashboard.component';
import {AuthService} from '../../../auth/auth.service';

@Component({
  selector: 'app-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.css']
})
export class MakePaymentComponent implements OnInit {
  public other_payment_mode: boolean;
  public add_money_valid: boolean;
  public is_valid_max = true;
  public amount;
  public account: string;
  public is_express_pay: boolean;
  public amount_of_40: number;
  public amount_of_50: number;
  public amount_of_70: number;
  public user_account_id: string;
  public is_user_account_id: boolean;
  public barcode_url: string;
  public is_content_load: boolean;
  public account_number: string;
  public mobile_phone_number: string;
  public is_barcode_load: boolean;
  public is_barcode_loader: boolean;
  public min_amount: number;
  public threshold_amount: number;
  public processing_charges: number;
  private first_recharge_min_amount: number;
  public initial_payment: string;
  public track_payment: boolean;
  public account_number_sg: any;
  public user_id: any;
  public is_loader: boolean;
  public account_balance;
  public pay_by_cash: boolean;
  public accountstatus: string;
  public expressDisplay: string;
  public personDetail: any;
  public freeTillDate: Date;
  public isAutoPay: boolean;
  public isCashOnly: boolean;
  public email_verified: boolean | undefined;
  public email_verification_required = true;
  public is_autopay_blocked = true;
  public is_start_date_today_valid = false;
  public is_start_date_today_invalid = false;
  public isMakingCardRecharge = false;
  public isPaymentSuccess = false;
  public back_text = '';

  public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private meta: Meta,
    private title: Title,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
	private authService: AuthService,
    public location: PlatformLocation,
    private localStorageService: LocalStorageService,
    private router: Router,
    private makePaymentService: MakePaymentService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private logger: LoggerService
  ) {
    this.addUpdateMetaTags();

    this.other_payment_mode = false;
    this.add_money_valid = true;
    this.is_valid_max = true;
    this.amount_of_40 = 40;
    this.amount_of_50 = 50;
    this.amount_of_70 = 70;
    this.min_amount = 1;
    this.threshold_amount = 0;
    this.processing_charges = 0;
    this.first_recharge_min_amount = 60;
    this.user_account_id = '';
    this.is_user_account_id = false;
    this.is_content_load = false;
    this.account_number = '';
    this.is_barcode_load = false;
    this.is_barcode_loader = true;
    this.barcode_url = 'assets/images/barcode.jpg';
    this.track_payment = false;
    this.is_loader = true;
    this.pay_by_cash = false;
    this.accountstatus = '';
    this.expressDisplay = '';
    this.isAutoPay = false;
    this.isCashOnly = false;

    this.sharedService.getConfigConst()
      .then(res => {
        if (res.status === 'success') {
          this.min_amount = res.results[0]['minAmount'];
          this.threshold_amount = res.results[0]['thresholdAmount'];
          this.processing_charges = res.results[0]['processingCharge'];
          this.first_recharge_min_amount = res.results[0]['firstRechargeMinAmount'];
          this.initial_payment = 'An initial recharge of $' + this.min_amount + ' is needed to start service.';
        }
      });
      let methodName = this.constructor.name + '.verifyToken';
    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          this.sharedService.setHeaderTitle('default_page');
          if (res.status === 'success' && res.isTerminated === false) {
            if (!res.isEnrolled) {
              this.router.navigate(['./dashboard']);
            } else {
              this.isCashOnly = res.cashOnly;
              const person = res.results[0]['personal'][0];
              this.email_verified = person.isEmailVerify === 1;
              this.email_verification_required = person.requiresEmailValidation;
              this.is_autopay_blocked = Boolean(person['isBlockAutopay']).valueOf();

              this.account_number = person['mobilePhoneNumber'];
              const service = res.results[0]['service'][0];

              const dataLayerAccountInfo = res.results[0]['personal'];

              const dataLayerEvent = 'Express Payment';
              (window as any).dataLayer.push({
                'event': dataLayerEvent,
                'accountID': dataLayerAccountInfo[0].id.toString(),
                'accountNumber': dataLayerAccountInfo[0].accountNumber.toString()
              });

              if (service) {
                this.freeTillDate = new Date(service['serviceStartDate']);
                this.freeTillDate.setDate(this.freeTillDate.getDate() + 5);
                this.freeTillDate = new Date(service['serviceStartDate']);
                const today = new Date();
                const service_date = this.datePipe.transform(this.freeTillDate, 'yyyy-MM-dd');
                const today_date = this.datePipe.transform(today, 'yyyy-MM-dd');

                this.is_start_date_today_valid = service_date === today_date && today.getHours() < 18;
                this.is_start_date_today_invalid = service_date === today_date && today.getHours() >= 18;
                this.freeTillDate.setDate(this.freeTillDate.getDate() + 3);
              }

              this.personDetail = person;

              this.dashboardService.getAutoPay(this.localStorageService.get('token')).then(res1 => {
                if (res1.status === 'success') {
                  this.isAutoPay = res1.autopayActive;
                }
              });

              if (person['accountStatusName'] === 'Enrollment' && person['balance'] < this.first_recharge_min_amount) {
                this.track_payment = true;
                this.sharedService.setHeaderTitleDynamicVal('add_money', 'Add Money', 'to turn on your power.');
              }

              if (this.track_payment) {
                this.amount_of_40 = 20;
                this.amount_of_50 = 30;
                this.amount_of_70 = 50;
              }

				this.is_content_load = true;
				this.is_loader = false;

              this.user_account_id = person['accountNumber'];
              if (person['balance'] > 0) {
                const that = this.sharedService;
                this.account_balance = person['balance'];
                setTimeout(function () {
                  that.setHeaderErrorMessage('make_payment', false, 'notification error', '');
                  that.setHeaderUserLoggedIn('make_payment', true, person);
                  that.setHeaderTitleDynamicVal('make_payment', '' + person['balance'], '');
                }, 10);
              } else {
                const that = this.sharedService;
                setTimeout(function () {
                  that.setHeaderErrorMessage('make_payment', false, 'notification error', '');
                  that.setHeaderUserLoggedIn('add_money', true, person);
                }, 10);
              }
            }
            if (this.isCashOnly) {
              this.payByCash();
            }
            this.activatedRoute.params.subscribe((params: Params) => {
              this.amount = params['amount'];
              if (params['method'] !== undefined) {
                if (params['method'] === 'cash') {
                  this.payByCash();
                }
              }
            });
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.set('returnUrl', 'make-payment');
            this.router.navigate(['./sign-in']);
          }
        }, (error) => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex) => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            exception: ex
          };
          this.logger.logError(JSON.stringify(logObj));
        });
    } else {
      this.sharedService.setHeaderTitle('default_page');
      const that = this.sharedService;
      this.is_loader = true;
      this.is_content_load = false;
      if (this.localStorageService.get('mobile_phone') != null) {
        this.isCashOnly = this.localStorageService.get('cash_only');
        this.account = '' + this.localStorageService.get('mobile_phone');
        this.account_number = '' + this.localStorageService.get('mobile_phone');
        this.mobile_phone_number = '' + this.localStorageService.get('mobile_phone');
        this.account_number_sg = this.localStorageService.get('account_number');
        this.back_text = 'Back';
        this.account = conformToMask(this.account, this.phoneMask, { guide: false }).conformedValue;
        this.account_number = conformToMask(this.account_number, this.phoneMask, { guide: false }).conformedValue;

        if (this.account != null) {

			this.authService.isValidOTP(this.account_number_sg).then((res) => {
				if (res) {
					this.email_verified = true;
					this.email_verification_required = true;
				}
			});

          methodName = this.constructor.name + '.barcodeImage';
          this.makePaymentService.barcodeImage({ 'accountNumber': '' + this.localStorageService.get('account_number') }).then(res => {

            const logObj = {
              method: methodName,
              request: 'AccountNumber : [masked]',
              response: res
            };
            this.logger.logInfo(JSON.stringify(logObj));
            this.is_barcode_loader = false;
            this.is_loader = false;
            this.is_express_pay = true;
            this.is_content_load = true;

            this.sharedService.setHeaderTitleDynamicVal('add_money', '', '');
            this.sharedService.setHeaderUserLoggedIn('add_money', false, '');
            this.sharedService.setHeaderErrorMessage('add_money', false, 'notification error', '');
            if (res.status === 'success') {
              this.barcode_url = res.barcodeLink;
              this.is_user_account_id = true;
              const dataLayerAccountInfo = res.results[0]['personal'];

              const dataLayerEvent = 'Express Pay';
              (window as any).dataLayer.push({
                'event': dataLayerEvent,
                'accountID': dataLayerAccountInfo[0].id.toString(),
                'accountNumber': dataLayerAccountInfo[0].accountNumber.toString()
              });
            } else {
              this.is_barcode_load = true;
            }
          }, (error) => {
            const logObj = {
              method: methodName,
              request: 'AccountNumber : [masked]',
              exception: error
            };
            this.logger.logError(JSON.stringify(logObj));
          }).catch((ex) => {
            const logObj = {
              method: methodName,
              request: 'AccountNumber : [masked]',
              exception: ex
            };
            this.logger.logError(JSON.stringify(logObj));
          });
          if (this.isCashOnly) {
            this.payByCash();
          }
        } else {
          this.localStorageService.set('returnUrl', 'make-payment');
          this.router.navigate(['./sign-in']);
        }
      } else if (this.localStorageService.get('email') != null) {
        this.isCashOnly = this.localStorageService.get('cash_only');
        this.account = '' + this.localStorageService.get('email');
        this.account_number = '' + this.localStorageService.get('email');
        this.back_text = 'Back';
        this.account_number_sg = this.localStorageService.get('account_number');
        this.user_id = this.localStorageService.get('user_id');
        let dataLayerEvent = 'Express Pay';
        (window as any).dataLayer.push({
          'event': dataLayerEvent,
          'accountID': this.user_id ? this.user_id.toString() : '',
          'accountNumber': this.account_number_sg
        });

        if (this.account != null) {
			this.authService.isValidOTP(this.account_number_sg).then((res) => {
				if (res) {
					this.email_verified = true;
					this.email_verification_required = true;
				}
			});
          this.makePaymentService.barcodeImage({ 'accountNumber': '' + this.localStorageService.get('account_number') }).then(res => {
            this.is_barcode_loader = false;
            this.is_loader = false;
            this.is_express_pay = true;
            this.is_content_load = true;

            this.sharedService.setHeaderTitleDynamicVal('add_money', '', '');
            this.sharedService.setHeaderUserLoggedIn('add_money', false, '');
            this.sharedService.setHeaderErrorMessage('add_money', false, 'notification error', '');
            if (res.status === 'success') {
              this.barcode_url = res.barcodeLink;
              this.is_user_account_id = true;
              dataLayerEvent = 'Express Pay';
              (window as any).dataLayer.push({
                'event': dataLayerEvent,
                'accountID': this.user_id.toString(),
                'accountNumber': this.account_number_sg
              });
            } else {
              this.is_barcode_load = true;
            }
          });
          if (this.isCashOnly) {
            this.payByCash();
          }
        } else {
          this.localStorageService.set('returnUrl', 'make-payment');
          this.router.navigate(['./sign-in']);
        }
      } else {
        this.router.navigate(['./ExpressPay']);
      }

    }
  }
  createBarcode() {
	  this.makePaymentService.barcodeImage({ 'accountNumber': this.user_account_id }).then(res1 => {
		  this.is_barcode_loader = false;
		  this.is_content_load = true;
		  this.is_loader = false;
		  if (res1.status === 'success') {
			  this.barcode_url = res1.barcodeLink;
			  this.is_user_account_id = true;
			  this.is_barcode_load = false;
		  } else {
			  this.is_barcode_load = true;
		  }
	  });
  }
  chargeUpOnline() {
    if (this.isCashOnly) {
      this.dialog.open(CashOnlyDialog);
    } else {
      this.isMakingCardRecharge = true;
    }
  }
  otherPaymentMode(status: boolean) {
    this.other_payment_mode = status;
  }
  addMoneyValid(add_money: any) {
    if (this.amount !== undefined) {
      this.amount = this.amount.trim();
    }

    if (this.amount !== '' && this.amount !== undefined && this.amount >= this.min_amount && this.amount <= 300) {
      this.add_money_valid = false;
      this.is_valid_max = true;
      if (add_money.keyCode === 13) {
        document.getElementById('add_money_btn').click();
      }
    } else {
      this.add_money_valid = true;
      this.is_valid_max = false;
    }
  }
  ngOnInit() {
  }

  updateEmailVerified(verified: boolean) {
    this.email_verified = verified;
  }

  updateEmail(response: { success: boolean, email: string }) {
    if (response.success) {
      this.account = response.email;
    }
  }

  gotoAutoRechargeSetup() {
    if (this.track_payment) {
      this.router.navigate(['./setup-autopay']);
    } else {
      this.router.navigate(['./manage_payment_methods']);
    }
  }

  addUpdateMetaTags() {
    this.title.setTitle('Recharge  | Pogo Energy');
    const titleTag = this.meta.getTag('name=title');

    if (titleTag !== undefined) {
      this.meta.updateTag({ name: 'title', content: 'Recharge  | Pogo Energy' });
    } else {
      this.meta.addTag({ name: 'title', content: 'Recharge  | Pogo Energy' });
    }

    const descriptionTag = this.meta.getTag('name=description');

    if (descriptionTag !== undefined) {
      this.meta.updateTag({
        name: 'description',
        content: 'Charge up your Pogo Energy account right on your phone or with cash at thousands of convenient cash locations.'
      });
    } else {
      this.meta.addTag({
        name: 'description',
        content: 'Charge up your Pogo Energy account right on your phone or with cash at thousands of convenient cash locations.'
      });
    }
  }
  backToExpressRecharge() {
    this.localStorageService.remove('email');
    this.localStorageService.remove('mobile_phone');
    this.localStorageService.remove('account_number');
    this.localStorageService.remove('used_mobile_no');
    this.localStorageService.remove('used_email');
    this.location.back();
  }

  redirectLocationPage() {
    window.location.href = this.localStorageService.get('msite_base_url') + 'locations';
  }

  selectMoney(amount: number) {
    if (this.amount !== undefined) {
      this.amount = this.amount.trim();
    }

    this.sharedService.setHeaderErrorMessage('make_payment', false, 'notification error', '');
    this.router.navigate(['./make-payment/' + amount]);
  }

  payByCash() {
    if (this.pay_by_cash === false) {
      this.sharedService.setHeaderTitleDynamicVal('add_money', 'Recharge with Cash', '');
      this.pay_by_cash = true;
	  this.createBarcode();
      if (this.track_payment === false) {
        this.sharedService.setHeaderErrorMessage('add_money', false, 'notification error', '');
        if (!this.is_express_pay) {
          this.sharedService.setHeaderUserLoggedIn('add_money', true, this.personDetail);
        }
      }
      if (this.accountstatus !== undefined && this.accountstatus === 'Enrollment') {
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('add_money', true, 'notification warning', ' ' + this.expressDisplay);
      }
    } else {
      if (this.track_payment === true) {
        this.sharedService.setHeaderTitleDynamicVal('add_money', 'Add Money', 'to turn on your power.');
      } else {
        if (this.localStorageService.get('token') == null && this.localStorageService.get('mobile_phone') != null) {
          this.sharedService.setHeaderTitleDynamicVal('add_money', '', '');
        } else {
          if (this.account_balance !== undefined) {
            this.sharedService.setHeaderTitleDynamicVal('make_payment', '' + this.account_balance, '');
          } else {
            this.sharedService.setHeaderTitleDynamicVal('add_money', 'Recharge', '');
          }
        }
      }
      this.pay_by_cash = false;
    }
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'service-not-start-warning',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><p>Oops, your amount is below the minimum of ${{amount | number:"1.2-2"}}  required to start service.</p></div></div><div class="footer"><button mat-button class="double-block-btn" (click)="cancel()" style="width:50%;display: inline-block;border-bottom-left-radius: 7px;">Change Amount</button><button mat-button class="double-block-btn" (click)="proceed()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Continue</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class ServiceWillNotStartDialog {
  public amount: number;
  constructor(public dialogRef: MatDialogRef<ServiceWillNotStartDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.amount = this.data.pay_amount
  }
  proceed() {
    this.dialogRef.close({ 'status': true });
  }

  cancel() {
    this.dialogRef.close({ 'status': false });
  }
}




// WEBPACK FOOTER //
// ./src/app/payment/make-payment/make-payment/make-payment.component.ts